// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__6pTfd","alertIcon":"ConfirmModal_alertIcon__1SIdF"};